
import { computed, defineComponent, markRaw, nextTick, onBeforeUnmount, onMounted, ref, watchEffect } from 'vue'
import * as echarts from 'echarts';
import OpenChatReportApi from '@/api/OpenChatReportApi';
import { getTodayNowTime, getTodayStartTime } from '@/utils/date.util';
import { ThemeModule } from '@/store/modules/theme.module';

export default defineComponent({
  setup () {
    let timer = 0
    const myEcharts = ref<echarts.ECharts>()
    const option = {
      // title: {
      //   show: false,
      //   text: '暂无会话数据',
      //   left: 'center',
      //   top: 'center',
      //   textStyle: {
      //     fontSize: 12,
      //     fontWeight: 'normal'
      //   }
      // },
      tooltip: {
        trigger: 'item',
        borderWidth: 0,
        extraCssText: 'background: linear-gradient(304.17deg, rgba(36, 176, 255, 0.6) -6.04%, rgba(9, 67, 132, 0.6) 85.2%); border-radius: 6px',
        textStyle: {
          fontSize: 12,
          color: 'var(--main-font-color)'
        }
      },
      color: ['#0A9CFD', '#52C5FF', '#0E42D2'],
      legend: {
        left: '70%',
        top: 'center',
        icon: 'circle',
        orient: 'vertical',
        itemWidth: 10,
        itemHeight: 10,
        itemGap: 20
      },
      series: [
        {
          name: '会话状态',
          type: 'pie',
          center: ['30%', '50%'],
          radius: ['55.5%', '74.4%'],
          left: '0%',
          top: '10%',
          minAngle: 0,
          avoidLabelOverlap: true,
          showEmptyCircle: false,
          label: {
            show: true,
            position: 'center',
            formatter: '{d}%'
          },
          labelLine: {
            show: true
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 20
            }
          }
        }
      ]
    }

    const themeColors = computed(() => ThemeModule.themeColors)

    watchEffect(() => {
      myEcharts.value && myEcharts.value.setOption({
        title: {
          textStyle: {
            color: themeColors.value['font-color-08']
          }
        },
        legend: {
          textStyle: {
            color: themeColors.value['font-color-08']
          }
        },
        series: [{
          label: {
            color: themeColors.value['font-color-06']
          }
        }]
      })
    })

    function renderChart () {
      const chartDom = document.getElementById('session-status') as HTMLElement;
      myEcharts.value = markRaw(echarts.init(chartDom))
      myEcharts.value.setOption(option)
      chartDom.removeAttribute("_echarts_instance_")
    }

    function chatStatusCountReport () {
      OpenChatReportApi.chatStatusCountReport({
        startDate: getTodayStartTime(),
        endDate: getTodayNowTime(),
        groupTime: 'day',
        status: ['canceled', 'linUp', 'realResponseCount']
      }).then((res:any) => {
        const data = [
          { value: res[0]?.linUpCount || 0, name: '排队中' },
          { value: res[0]?.canceledCount || 0, name: '漏接会话' },
          { value: res[0]?.responseCount || 0, name: '已接通会话' }
        ]
        myEcharts.value && myEcharts.value.setOption({
          series: [
            {
              label: {
                position: 'outside',
                formatter: '{d}%'
              },
              data: data
            }
          ]
        })
        timer = setTimeout(() => {
          chatStatusCountReport()
        }, 5000);
      })
    }

    function reasize () {
      myEcharts.value && myEcharts.value.resize()
    }
    
    onMounted(() => {
      renderChart()
      chatStatusCountReport()
      window.addEventListener('resize', reasize)
    })

    onBeforeUnmount(() => {
      clearTimeout(timer)
    })

    return {}
  }
})
